import { addModuleStyles } from '@glu/theming/glu-css-override';

const themeKey = 'legacySwitches';

const defaultTheme = ({ legacy, palette }) => (legacy ? undefined : {
  backgroundColor: palette.primary.darkBackground,
  labelColor: palette.text.light,
  focusColor: palette.focus.normal
});

const styles = ({ legacySwitches }) => (legacySwitches ? {
  root: {
    '& .glu-switch': {
      overflow: 'visible',
      '& input + label:before': {
        backgroundColor: legacySwitches.backgroundColor
      },
      '& label': {
        color: legacySwitches.labelColor
      },
      '& input': {
        '&:focus': {
          '& + label': {
            outline: `1px solid ${legacySwitches.focusColor}`,
            outlineOffset: 0
          }
        }
      }
    }
  }
} : {});

addModuleStyles(styles, themeKey, defaultTheme);
